import React from 'react';
import OpenProductDetail from '../../../../../components/link/OpenProductDetail';
import OpenPreviewProductDetail from '../../../../../containers/app/common/OpenPreviewProductDetail';
import TableFilterInput from '../../../../../components/table/TableFilterInput';
import OpenBrandDetail from '../../../../../components/link/OpenBrandDetail';
import Select from '../../../../../components/input/Select/Select';
import DateRangePicker from '../../../../../components/datePicker/DateRangePicker';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import { PRODUCT_STATUS_SELECT_LIST, PRODUCT_STATUS_TEXT } from '../../../../../constants/service/app/productConstants';
import { addAllItemToSelectList } from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';
import TableColumnImg from '../../../../../components/table/TableColumnImg';

/**
 *  좋아요한 상품 리스트 컬럼
 */
const columns = (data) => {
  const { filterOption, onFilter, mainProductCategorySelectList } = data;

  return [
    {
      accessor: 'url',
      Header: '메인 이미지',
      width: 120,
      Cell: (row) => <TableColumnImg url={row.value} />,
    },
    {
      accessor: 'productId',
      Header: '상품 ID',
      filterable: true,
      width: 100,
      Cell: (row) => <OpenProductDetail text={row.value} productId={row.value} />,
      Filter: () => (
        <TableFilterInput option={filterOption.productId} onFilter={(productId) => onFilter({ productId })} />
      ),
    },
    {
      accessor: 'productName',
      Header: '상품명',
      filterable: true,
      Cell: (row) => <OpenPreviewProductDetail text={row.value} productId={row.original.productId} />,
      Filter: () => (
        <TableFilterInput option={filterOption.productName} onFilter={(productName) => onFilter({ productName })} />
      ),
    },
    {
      accessor: 'mainCategory',
      Header: '1차 카테고리',
      filterable: true,
      Filter: () => (
        <Select
          list={addAllItemToSelectList(mainProductCategorySelectList)}
          onChange={(mainCategory) =>
            onFilter({
              mainCategory,
              subCategory: null,
            })
          }
          defaultValue={filterOption.mainCategory}
          value={filterOption.mainCategory}
          isTable={true}
          size="large"
        />
      ),
    },
    {
      accessor: 'storeName',
      Header: '브랜드명',
      filterable: true,
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.original.storeId} />,
      Filter: () => (
        <TableFilterInput option={filterOption.storeName} onFilter={(storeName) => onFilter({ storeName })} />
      ),
    },
    {
      accessor: 'storeId',
      Header: '브랜드 ID',
      filterable: true,
      width: 100,
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.value} />,
      Filter: () => <TableFilterInput option={filterOption.storeId} onFilter={(storeId) => onFilter({ storeId })} />,
    },
    {
      accessor: 'productStatus',
      Header: '상품 상태',
      filterable: true,
      width: 120,
      Cell: (row) => PRODUCT_STATUS_TEXT[row.value] || '_',
      Filter: () => (
        <Select
          list={addAllItemToSelectList(PRODUCT_STATUS_SELECT_LIST)}
          onChange={(status) => onFilter({ status })}
          defaultValue={filterOption.status}
          value={filterOption.status}
          isTable={true}
          size="large"
        />
      ),
    },
    {
      accessor: 'createDate',
      Header: '상품 좋아요 일시',
      filterable: true,
      sortable: true,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_KOREAN_FORMAT),
      Filter: () => (
        <DateRangePicker
          value={filterOption.createDate}
          outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
          onSelect={(createDate) => onFilter({ createDate })}
        />
      ),
    },
  ];
};

export default columns;
